import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Enterprise } from '../components/Enterprise';
import { useEffect } from 'react';
import backgroundImage from '@/assets/xrepl-landing.png';

export function EnterprisePage() {
  useEffect(() => {
    document.title = 'xReplAI - Enterprise';
  }, []);

  return (
    <div 
      className="min-h-screen bg-white dark:bg-[#0A1628]"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <Header />
      <Enterprise />
      <Footer />
    </div>
  );
}